<template>
  <PaginationWrapper
    :page="page"
    :totalCount="totalCount"
    @onPageChange="handlePageChange"
    export
    @exportTable="exportList"
  >
    <LogsManagerSearchOptions @onSearch="handleSearch" slot="search-options" />
    <div slot="table">
      <span class="section-title">
        {{ $t("sections.logsmLandingPage.table.title") }}
      </span>
      <LogsManagerTable />
    </div>
  </PaginationWrapper>
</template>
<script>
import { mapGetters } from 'vuex';
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import LogsManagerTable from '@/components/sections/logs/LogsManagerTable';
import LogsManagerSearchOptions from '@/components/sections/logs/LogsManagerSearchOptions';

export default {
  name: 'LogsManagerLandingPage',
  components: {
    PaginationWrapper,
    LogsManagerTable,
    LogsManagerSearchOptions,
  },
  data() {
    return {
      query: {},
      activeTab: 0,
      page: 1,
      totalCount: 0,
    };
  },
  computed: {
    ...mapGetters(['getPagePermissions']),
    ocpiPermissions() {
      return this.getPagePermissions('Logs Manager - OCPI');
    },
    ocppPermissions() {
      return this.getPagePermissions('Logs Manager - OCPP');
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      if (this.ocpiPermissions.read) {
        try {
          this.totalCount = await this.$store.dispatch('storeLogsOCPI', {
            query: {
              ...this.query,
              error: true,
            },
            page: this.page,
          });
        } catch (e) {
          console.log("Couldn't get OCPI logs.");
        }
      }
      if (this.ocppPermissions.read) {
        try {
          this.totalCount = await this.$store.dispatch('storeLogsOCPP', {
            query: {
              ...this.query,
              error: true,
            },
            page: this.page,
          });
        } catch (e) {
          console.log("Couldn't get OCPP logs.");
        }
      }
      this.$store.dispatch('storeLoading', false);
    },
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: {
            ...this.query,
            error: true,
          },
          type: 'logsManager',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', {
              type: 'logsManager',
            }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `logsManager-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'logsManager' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'logsManager' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
